// extracted by mini-css-extract-plugin
export var icon = "link-pass-module--icon--jN3KG";
export var nameText = "link-pass-module--name-text--79CLN";
export var wrapper = "link-pass-module--wrapper--cf74z";